module.exports = __webpack_public_path__ + "static/tartaglia2-banner-e01fda9437fb5dddfdfbd6b0c2cc6cb6.png";